import template from "./result.tpl";
import './result.css';

const DiseaseSearchResult = DomClass(template, function DiseaseSearchResult() {
	this.shortDescription = this.description.substr(0, 100);
	this.link = "?disease/" + this.normalizedName;
});

export default DiseaseSearchResult;